<template>
  <div class="">
    <div class="row" v-if="isActive || isFilled">
      <div class="col-xs-2 col-sm-2 col-md-1">
        <div
          class="number-circle lh35 cl-white brdr-circle align-center weight-700"
          :class="{ 'bg-cl-th-accent' : isActive, 'bg-cl-tertiary' : !isActive }"
        >
          6
        </div>
      </div>
      <div class="col-xs-8 col-sm-8 col-md-10">
        <div class="row">
          <div class="col-xs-12" :class="{ 'cl-bg-tertiary' : !isFilled && !isActive }">
            <h3 class="m0">
              {{ $t('Payment') }}
            </h3>
          </div>

        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-1 end-xs">
        <i data-v-0c2f6ec6="" class="material-icons arrow-i"
           :class="{ 'active' : isActive }"
        >keyboard_arrow_right</i>
      </div>
    </div>
    <div class="row mt15 delivery-method" v-if="isActive">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-6 flex center-xs" v-for="(method, index) in paymentMethods" :key="index">
            <label class="radioStyled py10 px10 middle-xs flex center-xs w-100" :class="{'is-checked' : method.code == selectedMethod}">
              <i class="material-icons cl-tertiary">{{method.img}}</i> {{ $t(method.title) }}
              <input
                type="radio"
                :value="method.code"
                name="payment-method"
                v-model="selectedMethod"
              >
            </label>
          </div>
          <span class="col-xs-12 validation-error cl-error h6" v-if="!selectedMethod">{{ $t('Field is required') }}</span>
        </div>
      </div>
    </div>
    <div class="row" v-if="isActive">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-md-8" style="margin: 15px auto">
            <button-full
              data-testid="paymentSubmit"
              @click.native="sendDataToCheckout"
              :disabled="!selectedMethod"
            >
              {{ $t('Go review the order') }}
            </button-full>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!isActive && isFilled">
      <div class="col-xs-12">
        <div class="lh30 flex end-xs" v-if="!isActive && isFilled">
          <a href="#" class="cl-tertiary flex" @click.prevent="edit">
              <span class="pr5 h6">
                {{ $t('Edit') }}
              </span>
            <i class="material-icons cl-tertiary">edit</i>
          </a>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="row fs16 brdr-bottom-1 brdr-cl-bg-secondary">
          <div class="col-xs-12 h4 mb15  bg-cl-secondary">
            <p>
              {{ $t(getSelectedPayment.title) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseCheckbox from 'theme/components/core/blocks/Form/BaseCheckbox'
  import BaseInput from 'theme/components/core/blocks/Form/BaseInput'
  import BaseSelect from 'theme/components/core/blocks/Form/BaseSelect'
  import ButtonFull from 'theme/components/theme/ButtonFull'
  import Tooltip from 'theme/components/core/Tooltip'

  export default {
    components: {
      ButtonFull,
      Tooltip,
      BaseCheckbox,
      BaseInput,
      BaseSelect
    },
    props: {
      isActive: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        paymentMethods: [
          {
            code: 'cash',
            title: 'Cash',
            img:'local_atm'
          },
          {
            code: 'card',
            title: 'Card charge',
            img:'payment'

          }
        ],
        selectedMethod: 'cash',
        isFilled: false
      }
    },
    computed: {
      getSelectedPayment () {
        return this.paymentMethods.find(method => method.code === this.selectedMethod)
      }
    },
    methods: {
      edit () {
        if (this.isFilled) {
          this.$bus.$emit('pickup-checkout-before-edit', 'payment')
        }
      },
      sendDataToCheckout () {
        this.$bus.$emit(
          'pickup-checkout-after-paymentDetails',
          this.paymentMethods.find(method => method.code === this.selectedMethod)
        )
        this.isFilled = true
      }
    }
  }
</script>
<style scoped lang="scss">
  .autocomplete {
    width: 100%;
    margin-bottom: 15px;
  }
  .delivery-method{
    label{
      cursor: pointer;
      font-size: 13px;
      @media (min-width: 769px) {
        font-size: 16px;
      }
    }
    i{
      margin-right: 5px;
      color: #000;
    }
    .is-checked{
      border: 1px solid #11bb2e;
      border-radius: 3px;
      background-color: #f2f2f2;
      i{
        color: #11bb2e;
      }
    }
    input {
      opacity: 0;
      padding: 0;
      height: 0;
    }
    .col-xs-6:first-child{
      border-right: 1px solid #efeff4;
    }
  }
</style>
